import {
  AuthSignInRequest,
  AuthSignInResponse,
  AuthRequestResetRequest,
  AuthResetPasswordRequest,
  AuthResetPasswordResponse,
  AuthVerifyResetTokenResponse,
  AuthUser,
} from "entities/auth";
import { GET, POST } from "utils/http";

const baseUrl = "/api/auth";

export const signIn = (body: AuthSignInRequest) =>
  POST<AuthSignInRequest, AuthSignInResponse>(`${baseUrl}/sign-in`, body, { skipAuthRedirect: true });

export const getMe = () => GET<AuthUser>(`${baseUrl}/me`);

export const requestReset = (body: AuthRequestResetRequest) =>
  POST<AuthRequestResetRequest>(`${baseUrl}/request-reset`, body, { skipAuthRedirect: true });

export const verifyResetToken = (token: string) =>
  GET<AuthVerifyResetTokenResponse>(`${baseUrl}/verify-reset-token`, { params: { token }, skipAuthRedirect: true });

export const verifyInvitationToken = (token: string) =>
  GET<AuthVerifyResetTokenResponse>(`${baseUrl}/verify-invitation-token`, { params: { token }, skipAuthRedirect: true });

export const resetPassword = (body: AuthResetPasswordRequest) =>
  POST<AuthResetPasswordRequest, AuthResetPasswordResponse>(`${baseUrl}/reset-password`, body, { skipAuthRedirect: true });
